import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                cultureBookTitle,
                cultureBookList0,
                shopInCultureBook,
                cultureBookList1,
                techListAd,
                techHardAd,
            },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="200140" type="struct" title="文化读书标题" groupName="文化读书" content={cultureBookTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="225739"
                    type="recommend"
                    title="文化读书列表1"
                    groupName="文化读书"
                    content={cultureBookList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="195861"
                    type="recommend"
                    title="文化读书区电商"
                    groupName="文化读书"
                    content={shopInCultureBook}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225744"
                    type="recommend"
                    title="文化读书列表2"
                    groupName="文化读书"
                    content={cultureBookList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={techListAd} />
                </Chip>
                <NoSSR>
                    <Ad content={techHardAd} styleName={styles.dbox} />
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
